import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { franklinConfig } from "./data";

export default function FranklinPage() {
  return <CityPageTemplate config={franklinConfig} />;
}